import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { lazy as loadable } from '@loadable/component'

import { wrapSuspenseComponent } from '@newComponents/SuspenseWrapper'

import { DocsSection } from '../shared/DocsSection'

const Overview = wrapSuspenseComponent(loadable(() => import('./Overview')))
const Creation = wrapSuspenseComponent(loadable(() => import('./Creation')))
const Page = wrapSuspenseComponent(loadable(() => import('./Page')))
const Settings = wrapSuspenseComponent(loadable(() => import('./Settings')))
const MultiHost = wrapSuspenseComponent(loadable(() => import('./MultiHost')))
const Rsvps = wrapSuspenseComponent(loadable(() => import('./Rsvps')))
const AttendeeForms = wrapSuspenseComponent(loadable(() => import('./AttendeeForms')))
const CheckIn = wrapSuspenseComponent(loadable(() => import('./CheckIn')))
const Visibility = wrapSuspenseComponent(loadable(() => import('./Visibility')))
const TicketingOverview = wrapSuspenseComponent(loadable(() => import('./TicketingOverview')))
const Stripe = wrapSuspenseComponent(loadable(() => import('./Stripe')))
const Tiers = wrapSuspenseComponent(loadable(() => import('./Tiers')))
const Discounts = wrapSuspenseComponent(loadable(() => import('./Discounts')))
const Orders = wrapSuspenseComponent(loadable(() => import('./Orders')))
const PurchaseFlow = wrapSuspenseComponent(loadable(() => import('./PurchaseFlow')))
const Messages = wrapSuspenseComponent(loadable(() => import('./Messages')))
const Embeds = wrapSuspenseComponent(loadable(() => import('./Embeds')))

const EventsSection = () => (
  <DocsSection section='events'>
    <Routes>
      <Route index element={<Overview />} />
      <Route path='overview' element={<Overview />} />
      <Route path='creation' element={<Creation />} />
      <Route path='page' element={<Page />} />
      <Route path='settings' element={<Settings />} />
      <Route path='multi-host' element={<MultiHost />} />
      <Route path='rsvps' element={<Rsvps />} />
      <Route path='attendee-forms' element={<AttendeeForms />} />
      <Route path='check-in' element={<CheckIn />} />
      <Route path='visibility' element={<Visibility />} />
      <Route path='ticketing-overview' element={<TicketingOverview />} />
      <Route path='stripe' element={<Stripe />} />
      <Route path='tiers' element={<Tiers />} />
      <Route path='discounts' element={<Discounts />} />
      <Route path='orders' element={<Orders />} />
      <Route path='purchase-flow' element={<PurchaseFlow />} />
      <Route path='messages' element={<Messages />} />
      <Route path='embeds' element={<Embeds />} />
    </Routes>
  </DocsSection>
)

export default EventsSection
